module.exports = __webpack_public_path__ + "static/img/image_j_lemonade.c2adfb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_j_lemonade.jpg
// module id = hjNm
// module chunks = 1